import { NgModule } from '@angular/core';

import { MaterialModule } from 'src/app/shared/modules/material/material.module';
import { SharedModule } from '../../shared/shared.module';
import { FooterComponent } from '../frontoffice/modules/shared/footer/footer.component';
import { FrontofficeRoutingModule } from './frontoffice-routing.module';
import { FrontofficeLayoutComponent } from './layout/layout.component';
import { AboutComponent } from './modules/components/about/about.component';
import { BlogComponent } from './modules/components/blog/blog.component';
import { ContactComponent } from './modules/components/contact/contact.component';
import { HomeComponent } from './modules/components/home/home.component';
import { MenuComponent } from './modules/components/menu/menu.component';
import { AboutSectionComponent } from './modules/pages/home/sections/about-section/about-section.component';
import { FeaturedOffersComponent } from './modules/pages/home/sections/featured-offers/featured-offers.component';
import { MenuTabsComponent } from './modules/pages/home/sections/menu-tabs/menu-tabs.component';
import { ProductoEditorDialogComponent } from './modules/pages/home/sections/producto-editor-dialog/producto-editor-dialog.component';
import { RecentNewsComponent } from './modules/pages/home/sections/recent-news/recent-news.component';
import { NavbarComponent } from './modules/shared/navbar/navbar.component';
import { PedidoConfirmadoDialogComponentComponent } from './modules/components/pedido-confirmado-dialog-component/pedido-confirmado-dialog-component.component';
import { CerradoComponent } from './modules/shared/cerrado/cerrado.component';

@NgModule({
  declarations: [
    FrontofficeLayoutComponent,
    HomeComponent,
    AboutComponent,
    ContactComponent,
    MenuComponent,
    BlogComponent,
    NavbarComponent,
    FooterComponent,
    AboutSectionComponent,
    FeaturedOffersComponent,
    MenuTabsComponent,
    RecentNewsComponent,
    ProductoEditorDialogComponent,
    PedidoConfirmadoDialogComponentComponent,
    CerradoComponent,
  ],
  imports: [FrontofficeRoutingModule, SharedModule],
})
export class FrontofficeModule {}
